<!-- Mobile Backdrop Overlay -->
@if (isOpen) {
  <div
    class="fixed inset-0 bg-stone-900/40 backdrop-blur-[2px] z-30 lg:hidden transition-opacity duration-300"
    (click)="closeMobile()"
  ></div>
}

<!-- Sidebar Container -->
<aside
  class="bg-surface-card border-r border-stone-200/80 flex flex-col justify-between transition-all duration-300 z-40 fixed lg:sticky top-0 h-screen shrink-0 select-none"
  [ngClass]="{
    '-translate-x-full lg:translate-x-0': !isOpen,
    'translate-x-0 shadow-modal': isOpen,
    'w-64': !isCollapsed || isOpen,
    'lg:w-20': isCollapsed && !isOpen
  }"
>
  <!-- Top Section: Brand & Navigation -->
  <div class="flex flex-col flex-1 min-h-0">
    <!-- Brand Header -->
    <div
      class="h-16 flex items-center transition-all duration-300 shrink-0"
      [ngClass]="{
        'justify-between px-5': !isCollapsed || isOpen,
        'justify-center px-2': isCollapsed && !isOpen
      }"
    >
      @if (!isCollapsed || isOpen) {
        <a
          routerLink="/backoffice/requestlist"
          [queryParams]="navQueryParams"
          (click)="closeMobile()"
          class="flex items-center gap-2 overflow-hidden focus:outline-none"
        >
          <img
            src="./../assets/logo-juboo.png"
            alt="Juboo"
            class="h-10 w-auto object-contain shrink-0"
          />
        </a>

        <!-- Desktop Collapse Toggle Button (inspired by mockup [<] icon) -->
        <button
          type="button"
          (click)="toggleCollapse()"
          class="text-stone-400 hover:text-primary p-1.5 rounded-lg hover:bg-surface transition hidden lg:flex items-center justify-center shrink-0 cursor-pointer"
          title="Réduire le menu"
        >
          <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="4" />
            <path d="M9 3v18" />
            <path d="M15 10l-2 2 2 2" />
          </svg>
        </button>
      } @else {
        <!-- Collapsed Header: Clickable to Expand -->
        <button
          type="button"
          (click)="toggleCollapse()"
          class="flex items-center justify-center p-2 rounded-xl hover:bg-surface transition-all w-full max-w-[56px] group cursor-pointer"
          title="Déplier le menu"
        >
          <img
            src="./../assets/favicon.png"
            alt="Juboo"
            class="h-8 w-8 object-contain transition-transform group-hover:scale-105"
          />
        </button>
      }

      <!-- Mobile Close Button -->
      @if (isOpen) {
        <button
          type="button"
          (click)="closeMobile()"
          class="text-stone-400 hover:text-stone-700 p-1.5 rounded-lg hover:bg-surface transition flex lg:hidden items-center justify-center cursor-pointer"
          title="Fermer le menu"
        >
          <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      }
    </div>

    <!-- Navigation Links -->
    <nav class="flex-1 overflow-y-auto no-scrollbar px-3 py-4 space-y-1">
      <!-- Réconciliations -->
      <a
        routerLink="/backoffice/requestlist"
        [queryParams]="navQueryParams"
        (click)="closeMobile()"
        class="flex items-center gap-3 px-3.5 py-2.5 rounded-xl text-sm transition-all border-l-4 group"
        [ngClass]="{
          'justify-center px-2': isCollapsed && !isOpen,
          'bg-primary-50 text-primary font-bold border-primary': isRouteActive(['/backoffice/requestlist', '/backoffice/createrequest', '/backoffice/requestdetail']),
          'text-stone-600 font-semibold border-transparent hover:bg-surface hover:text-primary': !isRouteActive(['/backoffice/requestlist', '/backoffice/createrequest', '/backoffice/requestdetail'])
        }"
        [title]="'BACKOFFICE.NAV.RECONCILIATIONS' | translate"
      >
        <div
          class="w-5 h-5 flex items-center justify-center shrink-0 transition-colors"
          [ngClass]="{
            'text-primary': isRouteActive(['/backoffice/requestlist', '/backoffice/createrequest', '/backoffice/requestdetail']),
            'text-stone-400 group-hover:text-primary': !isRouteActive(['/backoffice/requestlist', '/backoffice/createrequest', '/backoffice/requestdetail'])
          }"
        >
          <!-- Reconciliation Arrows Icon -->
          <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 9h16l-3.5-3.5" />
            <path d="M20 15H4l3.5 3.5" />
          </svg>
        </div>

        @if (!isCollapsed || isOpen) {
          <span class="truncate">{{ 'BACKOFFICE.NAV.RECONCILIATIONS' | translate }}</span>
        }
      </a>

      <!-- Lots / Bundles -->
      <a
        routerLink="/backoffice/batch-list"
        [queryParams]="navQueryParams"
        (click)="closeMobile()"
        class="flex items-center gap-3 px-3.5 py-2.5 rounded-xl text-sm transition-all border-l-4 group"
        [ngClass]="{
          'justify-center px-2': isCollapsed && !isOpen,
          'bg-primary-50 text-primary font-bold border-primary': isRouteActive(['/backoffice/batch-list', '/backoffice/create-batch', '/backoffice/details-batch']),
          'text-stone-600 font-semibold border-transparent hover:bg-surface hover:text-primary': !isRouteActive(['/backoffice/batch-list', '/backoffice/create-batch', '/backoffice/details-batch'])
        }"
        [title]="'BACKOFFICE.NAV.BATCH' | translate"
      >
        <div
          class="w-5 h-5 flex items-center justify-center shrink-0 transition-colors"
          [ngClass]="{
            'text-primary': isRouteActive(['/backoffice/batch-list', '/backoffice/create-batch', '/backoffice/details-batch']),
            'text-stone-400 group-hover:text-primary': !isRouteActive(['/backoffice/batch-list', '/backoffice/create-batch', '/backoffice/details-batch'])
          }"
        >
          <!-- Bundles Icon (stacked layers + box, matching mockup) -->
          <svg class="w-[18px] h-[18px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
            <path d="M7 3h10" />
            <path d="M5 6.5h14" />
            <rect x="3" y="10" width="18" height="11" rx="2.5" />
            <path d="M10 15h4" />
          </svg>
        </div>

        @if (!isCollapsed || isOpen) {
          <span class="truncate">{{ 'BACKOFFICE.NAV.BATCH' | translate }}</span>
        }
      </a>

      <!-- Configurations / Catégories -->
      <a
        routerLink="/backoffice/categories-list"
        [queryParams]="navQueryParams"
        (click)="closeMobile()"
        class="flex items-center gap-3 px-3.5 py-2.5 rounded-xl text-sm transition-all border-l-4 group"
        [ngClass]="{
          'justify-center px-2': isCollapsed && !isOpen,
          'bg-primary-50 text-primary font-bold border-primary ': isRouteActive(['/backoffice/categories-list']),
          'text-stone-600 font-semibold border-transparent hover:bg-surface hover:text-primary': !isRouteActive(['/backoffice/categories-list'])
        }"
        [title]="'BACKOFFICE.NAV.SETTINGS' | translate"
      >
        <div
          class="w-5 h-5 flex items-center justify-center shrink-0 transition-colors"
          [ngClass]="{
            'text-primary': isRouteActive(['/backoffice/categories-list']),
            'text-stone-400 group-hover:text-primary': !isRouteActive(['/backoffice/categories-list'])
          }"
        >
          <!-- Categories / Grid List Icon -->
          <svg class="w-[18px] h-[18px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="4" width="6" height="6" rx="1.5" />
            <rect x="3" y="14" width="6" height="6" rx="1.5" />
            <path d="M13 6h8" />
            <path d="M13 9h5" />
            <path d="M13 16h8" />
            <path d="M13 19h5" />
          </svg>
        </div>

        @if (!isCollapsed || isOpen) {
          <span class="truncate">{{ 'BACKOFFICE.NAV.SETTINGS' | translate }}</span>
        }
      </a>
    </nav>
  </div>

  <!-- Bottom Section: Customer Selector (visible only for Juboo agents, empty for clients) -->
  @if (isJubooAgent) {
    <div class="p-3 shrink-0 relative" #clientCardDropdownRef>
      <!-- Customer Dropdown Popover (opens upward in sidebar) -->
      @if (showCustomerList) {
        <div
          [ngClass]="(!isCollapsed || isOpen) ? 'right-3' : 'w-56'"
          class="absolute bottom-full left-3 mb-2 bg-surface-card rounded-2xl shadow-dropdown border-[1px] border-solid border-stone-200/90 overflow-hidden z-50 animate-fade-in"
        >
          <div class="p-2.5 border-b border-stone-100">
            <div class="relative flex items-center">
              <svg
                class="w-4 h-4 absolute left-3 text-stone-400 pointer-events-none"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M21 21l-4.35-4.35M17 11a6 6 0 11-12 0 6 6 0 0112 0z"
                />
              </svg>
              <input
                type="text"
                [placeholder]="'BACKOFFICE.NAV.SEARCH_CUSTOMER' | translate"
                (input)="onSearch($event)"
                [value]="searchTerm()"
                class="w-full pl-9 pr-3 py-1.5 text-xs sm:text-sm bg-surface-header/60 border-[1px] border-solid border-brand-border rounded-xl text-stone-800 placeholder:text-stone-400 outline-none hover:border-primary-200 focus:bg-surface-card focus:border-primary-300 focus:shadow-focus transition-[background-color,border-color,box-shadow]"
              />
            </div>
          </div>

          <ul class="max-h-60 overflow-y-auto divide-y divide-stone-100">
            @for (customer of filteredCustomers(); track customer.id || customer.name) {
              <li
                (click)="selectCustomer(customer)"
                class="flex items-center px-3.5 py-2.5 hover:bg-surface cursor-pointer transition-colors"
                [ngClass]="{ 'bg-primary-50/60': customerName === customer.name }"
              >
                <img
                  [src]="customer.logoPath ? customer.logoPath : defaultImage"
                  class="h-8 w-8 rounded-full object-cover mr-3 border-[1px] border-solid border-stone-200 shrink-0 bg-surface"
                  [alt]="customer.name"
                />
                <span
                  class="text-sm flex-grow truncate"
                  [ngClass]="{
                    'font-semibold text-primary': customerName === customer.name,
                    'font-medium text-stone-700': customerName !== customer.name
                  }"
                >
                  {{ customer.name }}
                </span>
                @if (customerName === customer.name) {
                  <svg class="w-4 h-4 text-primary ml-2 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7" />
                  </svg>
                }
              </li>
            }
            @if (filteredCustomers().length === 0) {
              <li class="px-4 py-4 text-xs text-stone-500 text-center">
                {{ 'INSTANCE.NO_RESULTS' | translate }}
              </li>
            }
          </ul>
        </div>
      }

      @if (!isCollapsed || isOpen) {
        <div
          (click)="onClientCardClick($event)"
          [ngClass]="{
            'border-primary-300 ring-2 ring-primary/10': showCustomerList
          }"
          class="rounded-2xl bg-surface/80 border-[1px] border-solid border-stone-200/80 px-3.5 py-3 flex items-center gap-3 transition-colors cursor-pointer hover:border-primary-200 hover:bg-primary-50/60"
        >
          <img
            [src]="imageUrl"
            [alt]="customerName"
            class="w-9 h-9 rounded-xl object-cover border-[1px] border-solid border-stone-200/80 bg-surface-card shrink-0"
          />
          <div class="flex flex-col min-w-0 flex-1">
            <span class="text-sm font-bold text-primary truncate">
              {{ customerName || '—' }}
            </span>
            <span class="text-xs text-stone-500 truncate">
              {{ customerSubtitle || ('BACKOFFICE.NAV.SWITCH_CLIENT' | translate) }}
            </span>
          </div>
          <svg
            class="w-4 h-4 text-stone-400 transition-transform duration-200 shrink-0"
            [class.rotate-180]="showCustomerList"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
          </svg>
        </div>
      } @else {
        <div
          (click)="onClientCardClick($event)"
          class="flex items-center justify-center py-1 cursor-pointer"
          [title]="customerName"
        >
          <img
            [src]="imageUrl"
            [alt]="customerName"
            class="w-9 h-9 rounded-xl object-cover border-[1px] border-solid border-stone-200/80 bg-surface-card"
          />
        </div>
      }
    </div>
  }
</aside>

